import { useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Return current params using on file manager
 * folderPath: current parent folder (folder contains left side folders)
 * selectedFolder: the folder contains folders & files on right side.
 * fileId: the selected file Id (use while editting file)
 */
const useFileManagerParams = () => {
  const location = useLocation();

  let fileId = '';
  let isEditingFolder = false;
  let folderPath = '';
  let selectedFolder = '';

  const remainingPath = location.pathname.replace('/admin/explorer/home', '');
  const splittedPaths = (remainingPath || '/').split('/');

  if (splittedPaths[splittedPaths.length - 1].startsWith('file:')) {
    fileId = splittedPaths[splittedPaths.length - 1].replace('file:', '');
    splittedPaths.splice(splittedPaths.length - 1, 1);
  }

  if (splittedPaths[splittedPaths.length - 1].startsWith('folder:edit')) {
    isEditingFolder = true;
    splittedPaths.splice(splittedPaths.length - 1, 1);
  }

  if (splittedPaths[1] !== '') {
    selectedFolder = `${splittedPaths.join('/')}`;
    folderPath = selectedFolder.substring(
      0,
      selectedFolder.lastIndexOf('/') + 1
    );
  } else {
    selectedFolder = '';
    folderPath = `${splittedPaths.join('/')}`;
  }

  const caches = useRef<{
    folderPath: string;
    fileId: string;
    selectedFolder: string;
    isEditingFolder: boolean;
  }>({
    folderPath,
    fileId,
    selectedFolder,
    isEditingFolder,
  });

  const fileManagerParams = useMemo<{
    folderPath: string;
    fileId: string;
    selectedFolder: string;
    isEditingFolder: boolean;
  }>(() => {
    caches.current = {
      folderPath,
      fileId,
      selectedFolder,
      isEditingFolder,
    };

    return {
      folderPath,
      fileId,
      selectedFolder,
      isEditingFolder,
    };
  }, [folderPath, fileId, selectedFolder, isEditingFolder]);

  return fileManagerParams;
};

export { useFileManagerParams };
